module.exports = __webpack_public_path__ + "static/img/why-5.da5b1b50.jpg";